export const Beschaeftigungsart = [
  {
    'PAISY Wert': 101,
    Bezeichnung: 'AN normale SV',
  },
  {
    'PAISY Wert': 102,
    Bezeichnung: 'Azubi',
  },
  {
    'PAISY Wert': 103,
    Bezeichnung: 'Altersteilzeit',
  },
  {
    'PAISY Wert': 104,
    Bezeichnung: 'Hausgewerbe',
  },
  {
    'PAISY Wert': 105,
    Bezeichnung: 'Praktikant',
  },
  {
    'PAISY Wert': 106,
    Bezeichnung: 'Werkstudent',
  },
  {
    'PAISY Wert': 107,
    Bezeichnung: 'Jugendl/Behind.',
  },
  {
    'PAISY Wert': 108,
    Bezeichnung: 'Vorruhestand',
  },
  {
    'PAISY Wert': 109,
    Bezeichnung: 'Geringf.Besch.',
  },
  {
    'PAISY Wert': 110,
    Bezeichnung: 'Kurzfr.Besch.',
  },
  {
    'PAISY Wert': 111,
    Bezeichnung: 'Maßnahme Reha',
  },
  {
    'PAISY Wert': 112,
    Bezeichnung: 'Fam-angeh.Landw',
  },
  {
    'PAISY Wert': 113,
    Bezeichnung: 'Nebenerw.Landw.',
  },
  {
    'PAISY Wert': 114,
    Bezeichnung: 'Nebenerw.Landw.',
  },
  {
    'PAISY Wert': 116,
    Bezeichnung: 'Ausgleich/FELEG',
  },
  {
    'PAISY Wert': 118,
    Bezeichnung: 'Berufsm. Unständig. Besch',
  },
  {
    'PAISY Wert': 119,
    Bezeichnung: 'Rentner',
  },
  {
    'PAISY Wert': 120,
    Bezeichnung: 'Altersrentner pfl.',
  },
  {
    'PAISY Wert': 121,
    Bezeichnung: 'Geringv.Azubi/Praktikant',
  },
  {
    'PAISY Wert': 122,
    Bezeichnung: 'Azubi außerbetr.Einricht.',
  },
  {
    'PAISY Wert': 123,
    Bezeichnung: 'Bufdi/freiw.soziales Jahr',
  },
  {
    'PAISY Wert': 124,
    Bezeichnung: 'Heimarbeiter',
  },
  {
    'PAISY Wert': 140,
    Bezeichnung: 'Seeleute',
  },
  {
    'PAISY Wert': 141,
    Bezeichnung: 'Azubi Seefahrt',
  },
  {
    'PAISY Wert': 142,
    Bezeichnung: 'Seeleute ATZ',
  },
  {
    'PAISY Wert': 143,
    Bezeichnung: 'Seelotse',
  },
  {
    'PAISY Wert': 144,
    Bezeichnung: 'Azubi Seeleute Geringverd',
  },
  {
    'PAISY Wert': 149,
    Bezeichnung: 'Rentner Seeleute frei',
  },
  {
    'PAISY Wert': 150,
    Bezeichnung: 'Rentner Seeleute pfl.',
  },
  {
    'PAISY Wert': 190,
    Bezeichnung: 'UV-Daten melden',
  },
  {
    'PAISY Wert': '000',
    Bezeichnung: 'Achtung: PGR fehlt',
  },
  {
    'PAISY Wert': 900,
    Bezeichnung: 'indiv.Pseudo-PGR',
  },
  {
    'PAISY Wert': 117,
    Bezeichnung: 'n.Berufsm. Unständ. Besch',
  },
];
